import React from 'react';

const BillingRunsIcon = () => {
    return (
        <svg data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M20 3V0h-2v3H6V0H4v3H0v21h24V3zm2 19H2V8h20z"/><path d="M4 10h2v2H4zM8 10h2v2H8zM17 10h2v2h-2zM17 18h2v2h-2zM4 18h2v2H4zM8 18h2v2H8zM4 14h2v2H4zM12.64 16l-1.83 1.83 1.41 1.41 2.83-2.83.71-.7a1 1 0 0 0 0-1.42l-.71-.7-2.83-2.83-1.41 1.41L12.64 14H8v2h4.64z"/></svg>
    )
};

export default BillingRunsIcon;